import React from 'react';

interface LoadingSpinnerProps {
    className?: string;
}

function LoadingSpinner({ className = '' }: LoadingSpinnerProps) {
    return (
        <div className={`flex items-center ${className}`}>
            <div className="relative flex items-center justify-center h-10 w-10">
                <div className="absolute inline-block w-10 h-10 border-4 border-t-primary border-gray-300 rounded-full animate-spin"></div>
            </div>
        </div>
    );
}

export default LoadingSpinner;
